import { render, staticRenderFns } from "./pqcForm.vue?vue&type=template&id=6f239dba&scoped=true"
import script from "./pqcForm.vue?vue&type=script&lang=js"
export * from "./pqcForm.vue?vue&type=script&lang=js"
import style0 from "./pqcForm.vue?vue&type=style&index=0&id=6f239dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f239dba",
  null
  
)

export default component.exports